import { SxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SummaryStyles = styled('div')(
    ({ theme }) => `
    border: 1px solid ${theme.palette.grey[200]};
    border-radius: 20px;
    padding: 16px;
    margin: 16px 0;
    background-color: #fff;
`,
);

export const FlexStyles = styled('div')<{ expanded?: boolean }>(
    ({ expanded }) => `
     cursor: pointer;
     display: flex;
     justify-content: space-between;
     align-items: center;
      padding-bottom: ${expanded ? '16px' : '0'};
      button {
      border: none;
      background-color: white;
      }
    `,
);

export const EditButton: SxProps = {
    padding: 0,
    minWidth: 0,
    marginLeft: '16px',
};

export const SummaryRowStyles = styled('div')`
    display: flex;
    justify-content: space-between;
`;

export const LabelStyles = styled('div')`
    display: flex;
    flex-direction: column;
    padding-bottom: 16px;
    gap: 8px;
`;

export const Label = styled('span')(
    ({ theme }) => `
    font-size: 14px;
    color: ${theme.palette.text.secondary};
`,
);
